<template>
<div class="reservations-table-row-body clearfix">
  <div class="-row" v-bind:style="rowStyle">
    <div
        v-for="tick in ticks"
        class="-cell"
        v-bind:style="cellStyle"
        @mouseover="$dispatch('tick-over', t)"
        @mouseout="$dispatch('tick-out', t)"
    ><slot></slot></div>
  </div>
</div>
</template>


<script>
import moment from 'moment'
require("moment-range")

export default {
  name: 'reservations-table-row-body',
  mixins: [require('mixin/style.vue')],
  props: {
    businessHour: {
      type: Object,
      required: true,
    },
    pxPerMinute: {
      type: Number,
      required: true,
    },
    minutesPerCell: {
      type: Number,
      required: true,
    },
    tickBorderWidth: {
      type: Number,
      default: 0,
    },
  },
  events: {
    'tick-set': function (tick) {
      this.tick = tick
      return true
    },
    'tick-clear': function () {
      this.tick = null
      return true
    },
  },
  data() {
    return {
      tick: null,
    }
  },
  computed: {
    rowStyle() {
      return this._rowStyle
    },
    _rowStyle() {
      let range = moment.range(`${this.businessHour.openAt}/${this.businessHour.closeAt}`)
      return {
        height: this.height + 'px',
        width: range.diff('minutes') * this.pxPerMinute + 'px',
      }
    },
    cellStyle() {
      return this._cellStyle
    },
    _cellStyle() {
      return {
        float: 'left',
        height: this.height + 'px',
        width: this.minutesPerCell * this.pxPerMinute + 'px',
        'line-height': this.height + 'px',
        border: `0 solid ${this.borderColorDefault}`,
        'border-top-width': this.borderTopWidth + 'px',
        'border-bottom-width': this.borderBottomWidth + 'px',
      }
    },
    ticks() {
      let ticks = []
      let range = moment.range(`${this.businessHour.openAt}/${this.businessHour.closeAt}`)
      let duration = moment.duration(this.minutesPerCell, 'minutes')
      range.by(duration, tick => ticks.push(tick), true)
      return ticks
    },
  },
  methods: {
    tickBorderStyle(tick, isEmpty) {
      if (isEmpty) {
        return 'none'
      }
      if (tick.minutes() === 0) {
        return 'solid'
      } else if (tick.minutes() === 30) {
        return 'dashed'
      } else {
        return 'dotted'
      }
    },
    cellStyleByTick(tick, isEmpty) {
      return this._cellStyleByTick(tick, isEmpty)
    },
    _cellStyleByTick(tick, isEmpty) {
      let style = Object.assign({}, this.cellStyle, {
        'border-left-style': this.tickBorderStyle(tick, isEmpty),
        'border-left-width': this.tickBorderWidth + 'px',
      })
      if (tick.isSame(this.tick)) {
        style['background'] = this.backgroundColorFocused
      }
      return style
    },
  },
}
</script>



// WEBPACK FOOTER //
// body.vue?80dd5d8a